<template>
  <div class="full-width">
    <dropdown-timetable :pageId="page.id" />
    <page-objects-container />
    <agenda class="pa-4" :agenda="agenda" v-if="agenda.length" />
    <page-buttons :buttons="buttons" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import routeNames from '@/router/routes'

export default {
  computed: {
    ...mapState({
      page: state => state.pages.page,
    }),
    ...mapGetters({ 
      authStatus: 'auth/authStatus',
      authToken: 'auth/authToken',
    }),
    buttons () {
      if (!this.page) return []
      return this.page.buttons.map((button) => {
        let urlTo = null
        let link = null
        if (button.url.startsWith('http')) {
          if (button.authenticated && !this.authStatus) {
            urlTo = { name:'login', query: { ['next-url']: button.url } }
          } else {
            link = button.url && this.authenticated ? `${ button.url }?x-api-key=${ this.authToken }` : button.url
          }
        } else {
          if (!!routeNames[button.url]) {
            urlTo = { name: button.url }
          } else {
            urlTo = { path: button.url }
          }
        }
        return { ...button, link, urlTo }
      })
    },

    agenda () {
      return this.page.pageSpecific.agenda
    },
  },
  components: {
    DropdownTimetable: () => import('@/components/view-components/webapp-pages/page-objects/DropdownTimetable.vue'),
    PageButtons: () => import('@/components/view-components/webapp-pages/page-objects/PageButtons.vue'),
    PageObjectsContainer: () => import('@/components/view-components/webapp-pages/page-objects/PageObjectsContainer.vue'),
    Agenda: () => import('@/components/view-components/webapp-pages/page-objects/Agenda.vue'),
  },
}
</script>
